module.exports = __webpack_public_path__ + "img/銓貫logo.19bc0cd4.png";